import React from "react";

// API functions for task management
const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    throw new Error('No authentication token found');
  }

  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

/**
 * Add a new task
 * @param {Object} taskData - Task data
 * @returns {Promise<Object>} - API response
 */
export const addTask = async (taskData) => {
  try {
    const response = await fetch(`${API_URL}/api/Tasks/AddTask`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(taskData),
    });

    // Check if response is successful
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`שגיאת שרת: ${response.status}`);
    }

    // Check if response is JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const responseText = await response.text();
      throw new Error('השרת החזיר תשובה לא תקינה');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Update existing task
 * @param {Object} taskData - Task data with TasksID
 * @returns {Promise<Object>} - API response
 */
export const updateTask = async (taskData) => {
  try {
    const response = await fetch(`${API_URL}/api/Tasks/UpdateTask`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(taskData),
    });

    // Check if response is successful
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`שגיאת שרת: ${response.status}`);
    }

    // Check if response is JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const responseText = await response.text();
      throw new Error('השרת החזיר תשובה לא תקינה');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Delete task
 * @param {Object} taskData - Object containing TasksID
 * @returns {Promise<Object>} - API response
 */
export const deleteTask = async (taskData) => {
  try {
    const response = await fetch(`${API_URL}/api/Tasks/DeleteTask`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(taskData),
    });

    // Check if response is successful
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`שגיאת שרת: ${response.status}`);
    }

    // Check if response is JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const responseText = await response.text();
      throw new Error('השרת החזיר תשובה לא תקינה');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Get all tasks for a specific building
 * @param {number} buildingId - Building ID
 * @returns {Promise<Object>} - API response with tasks array
 */
export const getTasks = async (buildingId) => {
  try {
    if (!buildingId) {
      throw new Error('Building ID is required');
    }

    const response = await fetch(`${API_URL}/api/Tasks/GetTasks/${buildingId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    });

    // Check if response is successful
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`שגיאת שרת: ${response.status}`);
    }

    // Check if response is JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const responseText = await response.text();
      throw new Error('השרת החזיר תשובה לא תקינה');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};